// eslint-disable-next-line no-unused-vars
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { ButtonPrimary, dlsColorWarning, IconWarning } from '@americanexpress/dls-react';
import { routes } from '../../constants/paths';

const ErrorMessage = () => {
  const onNavigation = () => {
    window.location.href = routes.home;
  };

  return (
    <div className="border text-align-center pad-3-tb" role="alert">
      <div className="pad-responsive-lr stack">
        <IconWarning id="icon-warning" size="xl" theme={dlsColorWarning} />
        <h1 className="heading-4 margin-1-b">{'We\'re sorry, but it looks like something went wrong.'}</h1>
        <p className="body-3">Please contact AMEX Representative for additional help and support .</p>
      </div>
      <hr className="margin-3-tb" />
      <ButtonPrimary onClick={onNavigation}>Try Again</ButtonPrimary>
    </div>
  );
};

export default ErrorMessage;
